"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var styles_1 = require("@material-ui/core/styles");

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var material_ui_audio_player_1 = __importDefault(require("material-ui-audio-player"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var Card_1 = __importDefault(require("../../../Card"));

var Header_1 = __importDefault(require("../../../Card/Header"));

require("./style.scss");

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * `Card` for displaying an Audio file, information, and playback controls
 */


var AudioPlayerCard = function AudioPlayerCard(_a) {
  var description = _a.description,
      image = _a.image,
      style = _a.style,
      src = _a.src,
      title = _a.title;
  var classes = (0, useStyles_1.default)();
  var muiTheme = (0, styles_1.createTheme)({});
  return react_1.default.createElement("div", {
    className: "story-audio-player-card",
    style: style
  }, react_1.default.createElement(Card_1.default, {
    style: {
      display: 'flex',
      minHeight: '60vh'
    }
  }, react_1.default.createElement("div", {
    className: classes.details
  }, react_1.default.createElement(CardContent_1.default, {
    className: classes.content
  }, react_1.default.createElement(Header_1.default, {
    text: title
  }), react_1.default.createElement(Divider_1.default, null), react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "subtitle1"
  }, description)), react_1.default.createElement("div", {
    className: classes.controls
  }, react_1.default.createElement(styles_1.MuiThemeProvider, {
    theme: muiTheme
  }, react_1.default.createElement(material_ui_audio_player_1.default, {
    src: src
  })))), image && react_1.default.createElement(CardMedia_1.default, {
    className: classes.cover,
    image: image,
    title: title
  })));
};

AudioPlayerCard.propTypes = {
  /** Additional information to place in the body of the `Card` */
  description: prop_types_1.default.string,

  /** accompany the Audio with an Artwork/Thumbnail image */
  image: prop_types_1.default.string,

  /** Source URL of the Audio file  */
  src: prop_types_1.default.string.isRequired,

  /** Determines the `CardHeader` text. */
  title: prop_types_1.default.string.isRequired,

  /** Styling object of the `Card` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
AudioPlayerCard.defaultProps = {
  description: '',
  image: undefined,
  style: {
    padding: 50
  }
};
exports.default = AudioPlayerCard;